"use strict";

exports.__esModule = true;
var _TicketTypesScreen = require("./TicketTypesScreen");
Object.keys(_TicketTypesScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketTypesScreen[key]) return;
  exports[key] = _TicketTypesScreen[key];
});